import axios from "axios";
import { toast } from "react-toastify";

export const APP_CONFIG = {
    // CRA env vars must start with `REACT_APP_`
    //"API": "https://api.dev.control.truventor.ai/api", /** Live */
    "API": process.env.REACT_APP_API || "http://localhost:3001/api", /** Development */
    "tOneUrl": process.env.REACT_APP_TONE_URL || "https://one.stage.truventor.com",
    // External partner service (used for machine type dropdown)
    "PARTNER_API_BASE":
      process.env.REACT_APP_PARTNER_API_BASE ||
      "https://partner.stage.truventor.com/api/v1/partner",
}

// For GET requests
axios.interceptors.request.use(
    (config) => {
        let auth = localStorage.getItem('auth')

       config.headers['Authorization'] = 'Bearer ' + auth
       return config;
    },
    (err) => {
       return Promise.reject(err);
    }
 );

 axios.interceptors.response.use(
    response => {
      return response
    },
    function (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        sessionStorage.clear();

        toast.error('Invalid login!', {
          position: "top-right",
          autoClose: 2500,
          theme: "colored",
        });

        // Force user back to login when token/session is invalid.
        if (window.location.pathname !== "/") {
          window.location.href = "/";
        }
      }

      return Promise.reject(error)
    }
  )